import React from 'react';
import {Alert, Stack} from '@mui/material';
import {
  designSystemToken,
  Icon,
  Label,
  IconName,
} from '@lightricks/react-design-system';
import {ErrorKind} from '@contentlab/stores/contentLabStore';

const ERROR_KIND_TO_ICON_NAME: Record<ErrorKind, IconName> = {
  [ErrorKind.VALIDATION]: 'Navigation-Notification',
  [ErrorKind.FAILURE]: 'Navigation-Attention',
};

interface SingleErrorDisplayProps {
  errorTitle: string;
  errorDescription: string;
  errorKind: ErrorKind;
  onClose?: () => void;
}

function SingleErrorDisplay({
  errorTitle,
  errorDescription,
  errorKind,
  onClose,
}: SingleErrorDisplayProps) {
  return (
    <Alert
      icon={
        <Icon
          name={ERROR_KIND_TO_ICON_NAME[errorKind]}
          size="large"
          appearance="primary"
        />
      }
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        width: '452px',
        backgroundColor: designSystemToken('semantic.bg.tertiary'),
        borderRadius: '16px',
        boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.1)',
      }}
      onClose={onClose}
    >
      <Stack direction="column" gap="4px">
        <Label size="md" whiteSpace="nowrap">
          {errorTitle}
        </Label>
        <Label
          size="md"
          color={designSystemToken('semantic.fg.secondary')}
          whiteSpace="normal"
        >
          {errorDescription}
        </Label>
      </Stack>
    </Alert>
  );
}

export default SingleErrorDisplay;
